const STORAGE_KEY = 'gf_invoice_sent_order_ids';

function readIds(): Set<string> {
  if (typeof sessionStorage === 'undefined') return new Set();
  try {
    const raw = sessionStorage.getItem(STORAGE_KEY);
    const parsed = raw ? JSON.parse(raw) : [];
    if (!Array.isArray(parsed)) return new Set();
    return new Set(parsed.filter((id) => typeof id === 'string' && id.trim()).map(String));
  } catch {
    return new Set();
  }
}

export function hasRememberedInvoiceSent(orderId: string): boolean {
  return readIds().has(String(orderId));
}

export function rememberInvoiceSent(orderId: string): void {
  const ids = readIds();
  ids.add(String(orderId));
  try {
    sessionStorage.setItem(STORAGE_KEY, JSON.stringify([...ids]));
  } catch {
    /* ignore quota errors; the in-memory order flag still updates this view */
  }
}
